import { useState, type FormEvent } from 'react'
import { api, ApiError } from '../../lib/api'
import { Link } from '../../lib/router'
import { Button, Notice, TextField } from '../../ui'
import { AuthLayout } from './AuthLayout'

export default function Forgot() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      const r = await api.post<{ message: string }>('/api/auth/forgot', { email })
      setSent(r.message)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Something went wrong. Please try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthLayout title="Reset password">
      <h2>Reset your password</h2>
      {sent ? (
        <>
          <Notice tone="good">{sent}</Notice>
          <p className="muted">Can’t see it? Check your junk folder, or ask the Briary office to help.</p>
          <div className="auth-links">
            <Link to="/login">Back to sign in</Link>
          </div>
        </>
      ) : (
        <form onSubmit={submit} noValidate>
          <p className="lead">Enter your email and we’ll send you a link to choose a new password.</p>
          {error && <Notice tone="bad">{error}</Notice>}
          <TextField label="Email" type="email" autoComplete="username" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
          <Button type="submit" variant="primary" size="lg" block busy={busy}>
            Send reset link
          </Button>
          <div className="auth-links">
            <Link to="/login">Back to sign in</Link>
          </div>
        </form>
      )}
    </AuthLayout>
  )
}
